var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 176V16H16V176H496Z",
    fill: "#C0392B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 336V176H16V336H496Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 496V336H16V496H496Z",
    fill: "#27AE60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M243.178 249.903C243.803 248.828 244.761 247.986 245.907 247.504C247.054 247.022 248.326 246.926 249.531 247.231C250.737 247.536 251.81 248.226 252.589 249.195C253.368 250.165 253.81 251.362 253.848 252.605V275.502H258.152V252.605C258.19 251.362 258.632 250.165 259.411 249.195C260.19 248.226 261.263 247.536 262.469 247.231C263.674 246.926 264.946 247.022 266.093 247.504C267.239 247.986 268.197 248.828 268.822 249.903C269.496 247.873 269.677 245.712 269.352 243.598C269.028 241.484 268.205 239.477 266.953 237.743C265.701 236.009 264.056 234.596 262.151 233.622C260.247 232.648 258.139 232.141 256 232.141C253.861 232.141 251.753 232.648 249.849 233.622C247.944 234.596 246.298 236.009 245.047 237.743C243.795 239.477 242.972 241.484 242.648 243.598C242.323 245.712 242.504 247.873 243.178 249.903Z",
    fill: "#F1C40F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M246.246 243.928C248.125 243.544 250.077 243.759 251.827 244.544C253.577 245.328 255.037 246.643 256 248.301C256.963 246.643 258.423 245.328 260.173 244.544C261.923 243.759 263.875 243.544 265.754 243.928C265.43 241.571 264.264 239.411 262.471 237.847C260.678 236.283 258.379 235.422 256 235.422C253.621 235.422 251.322 236.283 249.529 237.847C247.736 239.411 246.57 241.571 246.246 243.928",
    fill: "#F1C40F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M253.848 266.355C253.556 269.604 252.357 272.706 250.388 275.306C248.418 277.906 245.758 279.9 242.709 281.061C239.661 282.222 236.348 282.503 233.148 281.872C229.948 281.24 226.99 279.722 224.611 277.491C223.594 280.043 222.01 282.329 219.978 284.178C217.946 286.026 215.519 287.387 212.883 288.158C210.247 288.929 207.469 289.089 204.762 288.627C202.054 288.165 199.487 287.092 197.256 285.49C198.927 302.171 223.932 298.765 225.795 282.546C233.65 296.337 250.923 292.387 255.978 275.493L253.848 266.355Z",
    fill: "#F1C40F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M237.151 295.977C233.663 303.509 226.69 304.802 220.59 298.723C220.59 298.723 223.042 296.99 225.667 296.513C225.175 294.418 226.184 291.52 227.607 289.953C229.098 290.973 231.18 293.016 231.71 295.391C235.387 294.915 237.151 295.978 237.151 295.978L237.151 295.977Z",
    fill: "#F1C40F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M211.58 312.778C240.565 304.15 271.435 304.15 300.42 312.778Z",
    fill: "#F1C40F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M211.58 312.778C240.565 304.15 271.435 304.15 300.42 312.778",
    stroke: "#F8C300",
    strokeWidth: 13.7617
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M256 192.34L262.729 213.05L245.112 200.251H266.888L249.271 213.05L256 192.34Z",
    fill: "#F1C40F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTj);
export default __webpack_public_path__ + "static/media/TJ.1ce570c4794cfc451065ebab7a045d08.svg";
export { ForwardRef as ReactComponent };